import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const CardBestSeller = ({ ...props }) => {
  const renderCardImage = (image) => {
    if (image) {
      return image;
    } else {
      return "";
    }
  };
  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'VND',
    minimumFractionDigits: 0
  })

  let widthDetail = 300
  if(props.widthDetail)
    widthDetail = parseInt(props.widthDetail)

  // const link = `/product-detail/${props.productId}`
  return (
    <>
    <div className="swiper-slide">
        <div className="row productItem" style={{ paddingLeft:0, paddingRight:0, marginRight:25, marginLeft:25 }}>
            <NavLink to={`/product-detail/${props.productId}`} style={{color:"black"}}>
              <img src={renderCardImage(props.image)} className="productImage" style={{ width:"90%" }} />
              <div className="text-center">
                  <b>{props.productName}</b>
                  <br/>
                  {props.notes}
                  <br/>
                  {formatter.format(props.price)}
              </div>
              <div className="text-center" style={{ marginTop:"5%", fontSize:15 }} >
                  <i className="fas fa-chevron-right" id="arrowIcon"></i>
                  <hr className="divider" />
              </div>
            </NavLink>
        </div>
    </div>
    </>
  );
};

export default CardBestSeller;
